import { createSelector } from 'reselect'

// PLOP_APPEND_PATTERN_ANCHOR

export const membersSelector = createSelector(
  ({ teamMembers }) => teamMembers.membersList.members.results,
  results => results
)

export const membersNextSelector = createSelector(
  ({ teamMembers }) => teamMembers.membersList.members.next,
  next => next
)

export const membersIsLoadingSelector = createSelector(
  ({ teamMembers }) => teamMembers.membersList.members.isLoading,
  isLoading => isLoading
)

export const membersWasLoadedSelector = createSelector(
  ({ teamMembers }) => teamMembers.membersList.members.wasLoaded,
  wasLoaded => wasLoaded
)

export const membersErrorSelector = createSelector(
  ({ teamMembers }) => teamMembers.membersList.members.error,
  error => error
)

export const updatedMemberSelector = createSelector(
  ({ teamMembers }) => teamMembers.membersList.updatedMember,
  updatedMember => updatedMember
)

export const invitesSelector = createSelector(
  ({ teamMembers }) => teamMembers.invitesList.invites.results,
  results => results
)

export const invitesNextSelector = createSelector(
  ({ teamMembers }) => teamMembers.invitesList.invites.next,
  next => next
)

export const invitesIsLoadingSelector = createSelector(
  ({ teamMembers }) => teamMembers.invitesList.invites.isLoading,
  isLoading => isLoading
)

export const invitesWasLoadedSelector = createSelector(
  ({ teamMembers }) => teamMembers.invitesList.invites.wasLoaded,
  wasLoaded => wasLoaded
)

export const invitesErrorSelector = createSelector(
  ({ teamMembers }) => teamMembers.invitesList.invites.error,
  error => error
)

export const reinvitedUserSelector = createSelector(
  ({ teamMembers }) => teamMembers.invitesList.reinvitedUser,
  reinvitedUser => reinvitedUser
)

export const deletedInvitationSelector = createSelector(
  ({ teamMembers }) => teamMembers.invitesList.deletedInvite,
  deletedInvite => deletedInvite
)

export const memberCreateIsLoadingSelector = createSelector(
  ({ teamMembers }) => teamMembers.membersList.createdMember.isLoading,
  isLoading => isLoading
)

export const memberCreateErrorSelector = createSelector(
  ({ teamMembers }) => teamMembers.membersList.createdMember.error,
  error => error
)

export const betaInviteWasCreatedSelector = createSelector(
  ({ teamMembers }) => teamMembers.betaInvites.createBetaInvite.wasCreated,
  wasCreated => wasCreated
)

export const createBetaInviteIsLoadingSelector = createSelector(
  ({ teamMembers }) => teamMembers.betaInvites.createBetaInvite.isLoading,
  isLoading => isLoading
)

export const createBetaInviteErrorSelector = createSelector(
  ({ teamMembers }) => teamMembers.betaInvites.createBetaInvite.error,
  error => error
)

export const memberWasCreatedSelector = createSelector(
  ({ teamMembers }) => teamMembers.membersList.createdMember.wasCreated,
  wasCreated => wasCreated
)

export const inviteCreateErrorSelector = createSelector(
  ({ teamMembers }) => teamMembers.invitesList.createdInvite.error,
  error => error
)

export const inviteCreateIsLoadingSelector = createSelector(
  ({ teamMembers }) => teamMembers.invitesList.createdInvite.isLoading,
  isLoading => isLoading
)

export const inviteWasCreatedSelector = createSelector(
  ({ teamMembers }) => teamMembers.invitesList.createdInvite.wasCreated,
  wasCreated => wasCreated
)

// beta invites
export const acceptBetaInviteIsLoadingSelector = createSelector(
  ({ teamMembers }) => teamMembers.betaInvites.acceptBetaInvite.isLoading,
  isLoading => isLoading
)

export const acceptBetaInviteErrorSelector = createSelector(
  ({ teamMembers }) => teamMembers.betaInvites.acceptBetaInvite.error,
  error => error
)

export const betaInviteWasAcceptedSelector = createSelector(
  ({ teamMembers }) => teamMembers.betaInvites.acceptBetaInvite.wasAccepted,
  wasAccepted => wasAccepted
)

// account invites
export const acceptedInviteIsLoadingSelector = createSelector(
  ({ teamMembers }) => teamMembers.invitesList.acceptedInvite.isLoading,
  isLoading => isLoading
)

export const acceptedInviteErrorSelector = createSelector(
  ({ teamMembers }) => teamMembers.invitesList.acceptedInvite.error,
  error => error
)

export const inviteWasAcceptedSelector = createSelector(
  ({ teamMembers }) => teamMembers.invitesList.acceptedInvite.wasAccepted,
  wasAccepted => wasAccepted
)
